import * as React from 'react'
import { formatPrice } from '@helpers/price-helper'
import { IconWithText } from '@components/icon-with-text'
import { EndlessHolidayFormOption } from '@modules/product-package/details'

interface Props {
  option: EndlessHolidayFormOption
  amount: number
}

export const EndlessHolidaySideCardOptionSummaryRow = ({ option, amount }: Props): React.ReactNode => (
  <div className="d-flex justify-content-between align-items-center opacity-75 font-sm">
    <div className="font-xs font-500 col-8 pe-4">
      <IconWithText
        text={getOptionName(option)}
        iconClassName="uil-check font-md me-1"
        textClassName="text-truncate font-xs"
      />
    </div>
    <div className="col-1">{amount}x</div>
    <div className="col-3 text-end font-xs font-500">{formatPrice(option.price)}</div>
  </div>
)

const getOptionName = (option: EndlessHolidayFormOption) =>
  ({
    single_client_date: 'Jednorazowa zmiana daty"',
  }[option.kind])
